import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'

import elementEnLocal from 'element-ui/lib/locale/lang/en'
import elementZHLocal from 'element-ui/lib/locale/lang/zh-CN'
import elementTWLocal from 'element-ui/lib/locale/lang/zh-TW'

import enLocale from './en.json'
import zhHantLocale from './zh-Hant.json'
import zhHansLocale from './zh-Hans.json'

Vue.use(VueI18n)

const messages = {
    en: {
        ...elementEnLocal,
        ...enLocale,
    },
    'zh-Hans': {
        ...elementZHLocal,
        ...zhHansLocale,
    },
    'zh-Hant': {
        ...elementTWLocal,
        ...zhHantLocale,
    },
}

let urlObj = getQueryString()
let langCode = JSON.parse(localStorage.getItem('userCompanyInfo') || '{}').langCode || 'en'

const i18n = new VueI18n({
    locale: messages[urlObj.lang] ? (urlObj.lang || 'en') : (langCode === 'zh-HK' ? 'zh-Hant' : 'en'),
    messages,
})

function getQueryString() {
    const queryArr = window.location.search.substr(1).split('&')
    return queryArr.reduce((p: any, c: string) => {
        let arr: any[] = c.split('=')
        p[arr[0]] = arr[1]
        return p
    }, {})
}

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
